import './ScrollingCards.scss'

import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { ReactComponent as IconJourneys } from '../../../../assets/images/icons/icon-journeys.svg'
import { ReactComponent as RightArrow } from '../../../../assets/images/icons/icon-right-arrow.svg'
import CourseCard from '../../../courses/CourseCard'
import { ROUTE_COURSES_ALL } from 'components/common/helpers/Paths'
import { navigateTo } from '..'

// Initialize the intersection observer
const _previewObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    // Default to a blank image
    let imageSrc = entry.target.getAttribute('src') || ''

    // Show the thumbnail preview
    if (entry.isIntersecting)
      imageSrc = entry.target.getAttribute('data-preview-src') || imageSrc

    // Update the image src
    entry.target.style.backgroundImage = `url('${imageSrc}')`
  })
})

/**
 * ScrollingCards component. Used to display horizontally scrolling card component
 */
export default function ScrollingCards({
  title,
  courses,
  returnPath = null,
  emptyText = 'Nothing here yet',
  showAllButton = false,
  disableScroll = false
}) {
  const history = useHistory()
  const [cards, setCards] = useState()

  useEffect(() => {
    setCards(courses)
  }, [courses])

  return (
    <>
      {title && <h3>{title}</h3>}
      <div className={`scrolling-card-wrapper ${disableScroll ? 'no-scroll' : ''}`}>
        <div className='scrolling-card-cards'>
          {!!cards?.length ? (
            <>
              {cards.map(
                (course, i) =>
                  course && (
                    <CourseCard
                      key={course.id || course.ID}
                      course={course}
                      style={{ animationDelay: `${0.05 * i}s` }}
                      returnPath={returnPath}
                      observer={_previewObserver}
                    />
                  )
              )}
              {showAllButton && (
                <div className='my-3 p-4 course-card card card-all'>
                  <div
                    className='all-journeys-link'
                    onClick={() => navigateTo(ROUTE_COURSES_ALL, history)}
                  >
                    <div className='icon'>
                      <IconJourneys />
                    </div>
                    <h4 className='mt-3 mb-2'>Browse All Courses</h4>
                    <div className='icon'>
                      <RightArrow />
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className='no-cards'>
              <p>{emptyText}</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
